import Viewer from "../components/Viewer";
import { Machines } from "../graphql/querys/machines";

export default function MachinesScreenMobile() {
	return (
		<Viewer
			viewerInfo="machines"
			viewerQueryAll={Machines}
			detailPathBuilder={(machine) => `/machines-mobile/${machine._id}`}
		/>
	);
}
